import styled, { css } from 'styled-components';
import { FooterProps } from './Footer';

export const FooterElement = styled.footer<FooterProps>`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.secondary_500};
      color: ${theme.color.white};
      padding-top: 3rem;
    `;
  }};
`;

export const GridContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: grid;
      grid-template-rows: 1fr;
      gap: ${theme.spacing.md};
      padding: ${theme.spacing.md} ${theme.spacing.base};

      > :nth-child(1) {
        display: none;
      }

      // REDES SOCIAIS
      > :nth-child(7) {
        > ul {
          display: flex;
          gap: ${theme.spacing.sm};
          @media screen and (min-width: ${theme.breakpoint.lg}) {
            gap: ${theme.spacing.md};
          }
          > li {
            a {
              display: block;
              position: relative;
              width: ${theme.spacing.md};
              height: ${theme.spacing.md};
              background-repeat: no-repeat;
              background-position: center;
              background-size: 2.5rem;
              > span {
                display: none;
              }
              &.instagram {
                background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9167 6.16667C15.6896 6.16667 16.4224 6.47292 16.9766 7.02344C17.5307 7.57396 17.8333 8.31042 17.8333 9.08333V14.9167C17.8333 15.6896 17.5271 16.4224 16.9766 16.9766C16.426 17.5307 15.6896 17.8333 14.9167 17.8333H9.08333C8.31042 17.8333 7.5776 17.5271 7.02344 16.9766C6.46927 16.426 6.16667 15.6896 6.16667 14.9167V9.08333C6.16667 8.31042 6.47292 7.5776 7.02344 7.02344C7.57396 6.46927 8.31042 6.16667 9.08333 6.16667H14.9167ZM14.9167 5H9.08333C6.8375 5 5 6.8375 5 9.08333V14.9167C5 17.1625 6.8375 19 9.08333 19H14.9167C17.1625 19 19 17.1625 19 14.9167V9.08333C19 6.8375 17.1625 5 14.9167 5Z" fill="white"/><path d="M15.7917 9.08334C15.3068 9.08334 14.9167 8.69324 14.9167 8.20834C14.9167 7.72345 15.3068 7.33334 15.7917 7.33334C16.2729 7.33334 16.6667 7.72345 16.6667 8.20834C16.6667 8.69324 16.2729 9.08334 15.7917 9.08334ZM12 9.66668C13.287 9.66668 14.3333 10.713 14.3333 12C14.3333 13.287 13.287 14.3333 12 14.3333C10.713 14.3333 9.66667 13.287 9.66667 12C9.66667 10.713 10.713 9.66668 12 9.66668ZM12 8.50001C10.0677 8.50001 8.5 10.0677 8.5 12C8.5 13.9323 10.0677 15.5 12 15.5C13.9323 15.5 15.5 13.9323 15.5 12C15.5 10.0677 13.9323 8.50001 12 8.50001Z" fill="white"/></svg>');
              }
              &.issuu {
                background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.664 4C4.488 4.00035 4.31932 4.07042 4.19487 4.19487C4.07042 4.31932 4.00035 4.488 4 4.664V12C4 16.4187 7.58133 20 12 20C16.4187 20 20 16.4187 20 12C20 7.58133 16.4187 4 12 4H4.664ZM12.1107 6.388C13.5838 6.4019 14.9911 7.00039 16.0231 8.05182C17.055 9.10325 17.627 10.5215 17.6133 11.9947C17.5991 13.4676 17.0004 14.8746 15.949 15.9062C14.8977 16.9378 13.4796 17.5097 12.0067 17.496C8.942 17.466 6.476 14.956 6.504 11.8893C6.534 8.82267 9.044 6.35867 12.1107 6.388ZM12.09 7.90133C11.0117 7.8928 9.97405 8.31241 9.20476 9.06807C8.43548 9.82373 7.9974 10.8537 7.98667 11.932C7.97707 13.0116 8.39653 14.0508 9.15284 14.8212C9.90915 15.5917 10.9404 16.0303 12.02 16.0407C12.5541 16.0455 13.084 15.945 13.5793 15.745C14.0746 15.545 14.5256 15.2494 14.9066 14.875C15.2876 14.5007 15.5911 14.0549 15.7997 13.5632C16.0084 13.0715 16.1181 12.5435 16.1227 12.0093C16.1324 10.9308 15.7138 9.89245 14.9588 9.12225C14.2037 8.35205 13.1739 7.91295 12.0953 7.90133H12.09ZM12.0767 9.91C12.6233 9.91616 13.1451 10.1388 13.5279 10.529C13.9107 10.9193 14.1231 11.4454 14.1187 11.992C14.1162 12.2626 14.0604 12.5301 13.9545 12.7792C13.8486 13.0282 13.6946 13.254 13.5013 13.4434C13.3081 13.6329 13.0794 13.7824 12.8283 13.8834C12.5772 13.9844 12.3086 14.0349 12.038 14.032L12.0393 14.0313C11.4928 14.0264 10.9706 13.8045 10.5877 13.4146C10.2047 13.0246 9.99238 12.4985 9.99733 11.952C10.0023 11.4055 10.2241 10.8833 10.6141 10.5004C11.004 10.1174 11.5301 9.90505 12.0767 9.91Z" fill="white"/></svg>');
              }
              &.linkedin {
                background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.36 4H4.64C4.286 4 4 4.286 4 4.64V19.36C4 19.714 4.286 20 4.64 20H19.36C19.714 20 20 19.714 20 19.36V4.64C20 4.286 19.714 4 19.36 4ZM8.746 17.634H6.372V9.998H8.746V17.634ZM7.56 8.954C7.28785 8.954 7.02182 8.8733 6.79554 8.7221C6.56925 8.57091 6.39289 8.356 6.28874 8.10457C6.1846 7.85314 6.15735 7.57647 6.21044 7.30956C6.26353 7.04264 6.39458 6.79746 6.58702 6.60502C6.77946 6.41258 7.02464 6.28153 7.29156 6.22844C7.55847 6.17535 7.83514 6.2026 8.08657 6.30674C8.338 6.41089 8.55291 6.58725 8.7041 6.81354C8.8553 7.03982 8.936 7.30585 8.936 7.578C8.934 8.338 8.318 8.954 7.56 8.954ZM17.634 17.634H15.262V13.92C15.262 13.034 15.246 11.896 14.028 11.896C12.794 11.896 12.604 12.86 12.604 13.856V17.634H10.234V9.998H12.51V11.042H12.542C12.858 10.442 13.632 9.808 14.788 9.808C17.192 9.808 17.634 11.39 17.634 13.446V17.634Z" fill="white"/></svg>');
              }
              &.youtube {
                background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00888 13.0134H8.65777V16.2222H9.27999V13.0134H9.92888V12.4711H8.00888V13.0134Z" fill="white"/><path d="M11.2889 15.5556C11.1822 15.68 10.8178 15.9289 10.8178 15.5734V13.4489H10.2667V15.7689C10.2667 16.4711 10.9689 16.2845 11.2978 15.92V16.2222H11.8489V13.4489H11.2978V15.5556H11.2889Z" fill="white"/><path d="M13.3423 13.4311C13.0223 13.4311 12.8178 13.6711 12.8178 13.6711V12.4622H12.2578V16.2222H12.8178V16.0089C12.8178 16.0089 13.0045 16.2578 13.3423 16.2578C13.6356 16.2578 13.8578 16 13.8578 15.6444C13.8578 15.6444 13.8578 14.5244 13.8578 14.1067C13.8578 13.6889 13.6623 13.4311 13.3423 13.4311ZM13.28 15.5733C13.28 15.7778 13.1378 15.8756 12.9511 15.7956C12.9067 15.7778 12.8623 15.7422 12.8178 15.6978V13.9733C12.8534 13.9378 12.8978 13.9111 12.9334 13.8844C13.1289 13.7867 13.28 13.9378 13.28 14.1422V15.5733Z" fill="white"/><path d="M15.3333 15.4311C15.3333 15.6445 15.2178 15.7867 15.0844 15.7956C14.9422 15.8045 14.8 15.6889 14.8 15.4311V14.9067H15.8578V14.1956C15.8578 13.9378 15.76 13.7422 15.6267 13.6089C15.4756 13.4667 15.2711 13.3956 15.0667 13.3956C14.8711 13.3956 14.6667 13.4578 14.5067 13.5822C14.3378 13.7156 14.2311 13.92 14.2311 14.1956V15.44C14.2311 15.6889 14.3111 15.8845 14.4356 16.0267C14.5867 16.1867 14.7911 16.2756 15.0044 16.2845C15.2622 16.2933 15.5378 16.1867 15.6978 15.9645C15.7956 15.8311 15.8578 15.6533 15.8578 15.44V15.2978H15.3333C15.3333 15.2978 15.3333 15.3422 15.3333 15.4311ZM14.8 14.1956C14.8 14.0445 14.8889 13.8667 15.0578 13.8667C15.2267 13.8667 15.3333 14.0267 15.3333 14.1956C15.3333 14.3645 15.3333 14.48 15.3333 14.48H14.8C14.8 14.4711 14.8 14.3467 14.8 14.1956Z" fill="white"/><path d="M12 4C7.58222 4 4 7.58222 4 12C4 16.4178 7.58222 20 12 20C16.4178 20 20 16.4178 20 12C20 7.58222 16.4178 4 12 4ZM13.4044 6.99556H14.1156V9.37778C14.1156 9.52889 14.1867 9.52889 14.2133 9.52889C14.32 9.52889 14.48 9.41333 14.56 9.33333V6.98667H15.2711V10.1333H14.56V9.85778C14.4622 9.94667 14.3644 10.0178 14.2667 10.0711C14.1333 10.1422 14.0089 10.1689 13.8844 10.1689C13.7244 10.1689 13.6089 10.1156 13.52 10.0178C13.44 9.92 13.4044 9.76889 13.4044 9.58222V6.99556ZM11.1378 7.82222C11.1378 7.33333 11.5378 6.93333 12.0267 6.93333C12.5156 6.93333 12.9156 7.33333 12.9156 7.82222V9.33333C12.9156 9.82222 12.5156 10.2222 12.0267 10.2222C11.5378 10.2222 11.1378 9.82222 11.1378 9.33333V7.82222ZM9.28889 5.91111L9.71556 7.47556L10.1511 5.91111H10.96L10.1244 8.38222V10.1333H9.33333V8.38222L8.48 5.91111H9.28889ZM16.3111 17.0578C15.8578 17.5022 12.0178 17.5111 12.0178 17.5111C12.0178 17.5111 8.18667 17.5022 7.72444 17.0578C7.27111 16.6133 7.27111 14.4 7.27111 14.3822C7.27111 14.3733 7.27111 12.16 7.72444 11.7067C8.17778 11.2622 12.0178 11.2533 12.0178 11.2533C12.0178 11.2533 15.8489 11.2622 16.3111 11.7067C16.7644 12.1511 16.7733 14.3644 16.7733 14.3822C16.7733 14.3822 16.7733 16.6044 16.3111 17.0578Z" fill="white"/><path d="M12.0089 9.64447C12.16 9.64447 12.2311 9.55558 12.24 9.41336V7.72447C12.24 7.60892 12.1245 7.51114 12.0178 7.51114C11.9111 7.51114 11.7956 7.60003 11.7956 7.72447V9.41336C11.7956 9.54669 11.8578 9.63558 12.0089 9.64447Z" fill="white"/></svg>');
              }
            }
          }
        }
      }

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        padding: ${theme.spacing.md} 0;
        grid-template-columns: 3fr 2fr 1fr 1fr;
        grid-template-rows: auto;
        grid-template-areas:
          'col1 col2 col4 col5'
          'col1 col3 col6 col7';

        // VIAGENS NACIONAIS E INTERNACIONAIS
        > :nth-child(1) {
          display: block;
          grid-area: col1;
          > ul {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            margin-bottom: 1rem;
          }
        }
        // PARA SUA VIAGEM
        > :nth-child(2) {
          grid-area: col2;
        }
        // NEWSLETTER
        > :nth-child(3) {
          grid-area: col3;
        }

        // INFORMAÇÕES ÚTEIS
        > :nth-child(4) {
          grid-area: col4;
        }

        // SOBRE A KANGAROO
        > :nth-child(5) {
          grid-area: col5;
        }

        // REDES SOCIAIS
        > :nth-child(7) {
          grid-area: col7;
        }

        // CAMBIO DO DIA
        > :nth-child(6) {
          grid-area: col6;
        }

        > :nth-child(3),
        > :nth-child(6),
        > :nth-child(7) {
          border-top: 1px solid ${theme.color.neutral_200};
          padding-top: 2rem;
        }
      }
    `;
  }};
`;

export const MenuList = styled.ul`
  ${({ theme, ...props }) => {
    return css`
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        //
      }
    `;
  }};
`;
export const MenuListItem = styled.li`
  ${({ theme, ...props }) => {
    return css`
      padding: ${theme.spacing.sm} 0;
    `;
  }};
`;
